import { Component, OnInit } from '@angular/core';
import {
  AnnouncementService,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  MixedLoyaltyItem,
  MixedLoyaltyQuery,
  Scorecard,
  ScorecardQuery,
} from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  memberDetails$: Observable<MemberDetails | undefined>;
  scorecard$: Observable<Scorecard[]>;
  mixedLoyaltyItems$: Observable<MixedLoyaltyItem[]>;
  card$: Observable<MemberCard | undefined>;
  screenType = ScreenType;
  populations = Populations;

  constructor(
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private scorecardQuery: ScorecardQuery,
    private mixedLoyaltyService: MixedLoyaltyQuery,
    private announcementService: AnnouncementService
  ) {}

  ngOnInit() {
    this.card$ = this.memberCardQuery.selectObservedMemberCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();

    this.scorecard$ = this.scorecardQuery.selectAllScorecardSorted();
    this.mixedLoyaltyItems$ = this.mixedLoyaltyService.selectFavouriteMixedLoyaltyItems();
    this.announcementService.fetchAnnouncements().toPromise();
  }
}
